import AdvModal from 'components/organisms/AdvModal';

export default AdvModal;
